import React from 'react';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOpsReports = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-ops-reports", jiraSpaEntry: "async-jira-eoc-ops-reports" */ '@atlassian/jira-eoc-ops-reports'
		),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOpsReportsRedirect = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-ops-reports-redirect", jiraSpaEntry: "async-jira-eoc-ops-reports" */ '@atlassian/jira-eoc-ops-reports'
	).then((exportedMembers) => exportedMembers.OpsReportsRedirect),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyGlobalOpsReports = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-global-ops-reports-redirect", jiraSpaEntry: "async-jira-eoc-ops-reports" */ '@atlassian/jira-eoc-ops-reports'
	).then((exportedMembers) => exportedMembers.GlobalOpsReports),
);

export const OpsReportsRedirect = (): React.JSX.Element => (
	<LazyPage
		Page={LazyOpsReportsRedirect}
		pageId="async-jira-eoc-ops-reports-redirect"
		shouldShowSpinner={false}
	/>
);

export const GlobalOpsReports = (): React.JSX.Element => (
	<LazyPage
		Page={LazyGlobalOpsReports}
		pageId="async-jira-eoc-global-ops-reports"
		shouldShowSpinner={false}
	/>
);

export const OpsReports = (): React.JSX.Element => (
	<LazyPage Page={LazyOpsReports} pageId="async-jira-eoc-ops-reports" shouldShowSpinner={false} />
);
